import {register} from '@shopify/theme-sections'
import React from 'react'
import {createRoot} from 'react-dom/client'
import AlgoliaSearch from '../components/algolia/search'
import {getUrlParameterByName} from '../modules/utils'


// this should be imported globally via theme-header
import Sticky from '../modules/sticky'

import '../../styles/components/algolia-search-bar.scss'
import '../../styles/sections/template-collection-listing.scss'
import '../../styles/sections/template-collection-algolia.scss'
import $ from 'jquery'
import {getShopifyAlgoliaIndex} from '@/scripts/components/algolia/config'

export default register(`template-search-algolia`, {
  onLoad() {
    setTimeout(() => {
      const stickyFilter = document.querySelector(`.filters-group`)
      if (stickyFilter) {
        this.sticky = new Sticky({
          target: `.filters-group`,
          fillHeight: false,
          heightElements: false,
          unstickElement: `#shopify-section-theme-footer`,
          bodyClass: `fixed-filter`
        })
      }
    }, 3000)
    const view = this.container.dataset.view || `product`
    const collectionsContext = JSON.parse(
      this.container.querySelector(`[data-collections-json]`).innerHTML
    )
    const configAppCountry = this.container.dataset.shopCountry
    const shopifyAlgoliaIndicies = getShopifyAlgoliaIndex()
    const noResultContainer = this.container.querySelector(`[data-no-results]`)
    const navigationContext = JSON.parse(
      this.container.querySelector(`[data-navigation-json]`).innerHTML
    )

    const queryParams = getUrlParameterByName(`Search`)
    const searchQuery =
      queryParams && queryParams.replace(/[^a-zA-Z0-9-,. ]/g, ``)

    if (searchQuery) {
      let searchRoot = createRoot(this.container)
      searchRoot.render(
        <AlgoliaSearch
          view={view}
          collections={collectionsContext}
          country={configAppCountry}
          navigation={navigationContext}
          query={searchQuery}
          algoliaIndex = {shopifyAlgoliaIndicies}
          ref={query => {
            window.searchQuery = query
          }}
          searchValue={queryParams}
        />
      )
    } else {
      // ReactDOM.render(
      //   <SearchBar country={configAppCountry} />,
      //   this.container.querySelector('#filterSearchBar')
      // );
      if (noResultContainer) {
        noResultContainer.classList.remove(`hide`)
      }
    }

    const backToTop = document.querySelector(`[data-back-top]`)
    const bodyWrapper = document.querySelector(`.body-wrapper`)
    const aboveTheFold = function(event) {
      const scroll = bodyWrapper.scrollTop
      if (scroll > 1000) {
        backToTop.classList.add(`active`)
      } else {
        backToTop.classList.remove(`active`)
      }
    }
    if (backToTop) {
      backToTop.addEventListener(`click`, (event) => {
        event.preventDefault()
        bodyWrapper.scrollTop = 0
      })

      bodyWrapper.addEventListener(`scroll`, aboveTheFold)
      bodyWrapper.addEventListener(`resize`, aboveTheFold)
      bodyWrapper.addEventListener(`orientationchange`, aboveTheFold)
    }

    $(document).on(`click`, `.right-view-sort-main .view-inputs label[for="list"]`, () => {
      $(`#resultsContainer`).addClass(`collection-list-view`)
    })
    $(document).on(`click`, `.right-view-sort-main .view-inputs label[for="grid"]`, () => {
      $(`#resultsContainer`).removeClass(`collection-list-view`)
    })
    $(document).on(`click`, `#filterContainer .filters-title > span`, () => {
      $(`.custom-collection-layout #sidebar-content`).addClass(`sidebar-mobile-view`)
    })
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {}
})
